import Api, { FetchMethodType } from 'api/Api';
import { LinkSearchKindType } from 'enums/LinkSearchKindType';
import { ValidateEmployerProvidedIncomeData } from 'thunks/createValidateEmployerProvidedIncomeThunk';
import { GetApplicationDataResponse } from 'handlers/applicationData';

export enum PayrollProviderName {
  Argyle = 'Argyle',
  Pinwheel = 'Pinwheel',
  Atomic = 'Atomic',
  Manual = 'Manual',
  ManuallySendToHR = 'ManuallySendToHR',
}

export interface EmployerData {
  id: string;
  name: string;
  logo_url: string;
}

export interface ValidateEmployerProvidedIncomeResponse {
  incomeRequired: boolean;
}

export interface Employer {
  id: string;
  name: string;
  logo_url: string;
  provider: PayrollProviderName;
  kind: LinkSearchKindType;
}

export interface EmployersSearchParams {
  name: string;
  kind: LinkSearchKindType;
  providers: PayrollProviderName[];
}

export default class EmployersApi extends Api {
  public async searchEmployers({ name, kind, providers }: EmployersSearchParams): Promise<Employer[]> {
    const params = new URLSearchParams();
    params.set('name', name);
    params.set('kind', kind);
    providers.forEach((provider) => {
      params.append('provider', provider);
    });
    const results = await this.fetch<any[]>(`/employers?${params}`);
    return results.map((result) => ({ ...result, kind: result.response_type }));
  }

  public async getEmployerData(payrollProvider: string, employerId: string): Promise<EmployerData> {
    const result = await this.fetch(`/employers/${payrollProvider}/linkItem/${employerId}`);
    return result as EmployerData;
  }

  public async validateEmployerProvidedIncome(
    data: ValidateEmployerProvidedIncomeData,
  ): Promise<ValidateEmployerProvidedIncomeResponse> {
    const result = await this.fetch('/employers/validateEmployerProvidedIncome', {
      method: FetchMethodType.POST,
      body: data,
    });
    return result as ValidateEmployerProvidedIncomeResponse;
  }

  public async updatePayrollProviderToManual(applicationId: string): Promise<GetApplicationDataResponse> {
    const result = await this.fetch<GetApplicationDataResponse>(`/employers/${applicationId}/payrollProvider`, {
      method: FetchMethodType.PUT,
    });

    return result;
  }
}
